import React, { useState } from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMenu, FiShoppingBag, FiX } = FiIcons;

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <nav className="fixed top-0 w-full z-50 bg-[#0A0A0A]/90 backdrop-blur-md border-b border-[#333]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => setIsOpen(!isOpen)}
              className="text-white hover:text-acid transition-colors lg:hidden"
            >
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="w-6 h-6" />
            </button>
            <span className="text-2xl font-black tracking-tighter uppercase">
              Slate<span className="text-acid">Run</span>
            </span>
          </div>

          <div className="hidden lg:flex items-center gap-8 text-sm font-bold tracking-widest text-[#737373]">
            <a href="#drop" className="hover:text-white transition-colors">THE DROP</a>
            <a href="#lookbook" className="hover:text-white transition-colors">LOOKBOOK</a>
            <a href="#fit" className="hover:text-white transition-colors">FIT GUIDE</a>
            <a href="#info" className="hover:text-white transition-colors">INFO</a>
          </div>

          <div className="flex items-center">
            <button className="relative group p-2">
              <SafeIcon icon={FiShoppingBag} className="w-6 h-6 text-white group-hover:text-acid transition-colors" />
              <span className="absolute top-0 right-0 w-4 h-4 bg-acid text-black text-[10px] font-bold flex items-center justify-center rounded-full">
                0
              </span>
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <motion.div 
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="fixed inset-0 z-40 bg-black pt-24 px-6 flex flex-col gap-8 lg:hidden"
        >
          {['THE DROP', 'LOOKBOOK', 'FIT GUIDE', 'INFO'].map((item) => (
            <a 
              key={item}
              href={`#${item.toLowerCase().replace(' ', '')}`}
              onClick={() => setIsOpen(false)}
              className="text-4xl font-black uppercase tracking-tighter text-[#737373] hover:text-acid"
            >
              {item}
            </a>
          ))}
        </motion.div>
      )}
    </>
  );
};

export default Navbar;